import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { CUSTOM_ATTRIBUTE_VALUE_URL, GET_CUSTOM_ATTRIBUTES_BY_EVENT_ID } from '@/constants';
import { CustomAttributeType } from '@/enums';
import { apiUrl } from '@/helpers';

const customAttributeValueEndpoints = {
  getCustomAttributes: (eventId: number, customAttributeType: CustomAttributeType) =>
    axios.get(
      `${apiUrl()}${CUSTOM_ATTRIBUTE_VALUE_URL}/${eventId}/customAttributeType/${customAttributeType}`
    )
};

export const useGetCustomAttributesByEventType = (
  eventId: number,
  customAttributeType: CustomAttributeType
) => {
  return useQuery([GET_CUSTOM_ATTRIBUTES_BY_EVENT_ID, { eventId, customAttributeType }], () =>
    customAttributeValueEndpoints.getCustomAttributes(eventId, customAttributeType)
  );
};
